import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr} from '@angular/common/http';
import {ApplicationConfig, provideZonelessChangeDetection} from '@angular/core';
import {
  provideRouter,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation,
  withRouterConfig,
} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import { ROUTES } from './app.routes';
import {AuthJwtTokenInterceptor} from "./core/interceptors/auth-jwt-token-interceptor";
import {DialogService} from "primeng/dynamicdialog";
import {DatePipe} from "@angular/common";
import {providePrimeNG} from "primeng/config";
import {THEME_PRESET} from "./app.theme";
import {PRIMENG_LICENSE} from "./primeng-license.generated";

export const appConfig: ApplicationConfig = {
  providers: [
    // Без zone.js: экран обновляют только уведомления Angular — сигналы, события шаблона, async-пайп.
    // Поле, которое читает шаблон и пишет асинхронный колбэк, обязано быть сигналом.
    provideZonelessChangeDetection(),
    provideRouter(
      ROUTES,
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding(),
      // Вкладки страницы источника — именованные child-маршруты под ':sourceId'; со стратегией по
      // умолчанию (emptyOnly) параметр родителя не доходит до их signal inputs.
      withRouterConfig({paramsInheritanceStrategy: 'always'}),
    ),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    {provide: HTTP_INTERCEPTORS, useClass: AuthJwtTokenInterceptor, multi: true},
    providePrimeNG({
      // Ключ PrimeNG генерирует scripts/write-license-key.mjs из PRIMENG_LICENSE_KEY; пустой ключ — как «не задан».
      license: PRIMENG_LICENSE || undefined,
      theme: {
        preset: THEME_PRESET,
        options: {
          // Панель только светлая: 'none' отключает тёмные токены (по умолчанию 'system' — по настройке ОС).
          darkModeSelector: 'none',
          // Стили компонентов лежат в слое `primeng`; любые правила вне слоя (styles.css, компонентные CSS) выигрывают у них независимо от специфичности.
          // Порядок слоёв (PAR-12947): PrimeNG выводит его первым объявлением `@layer` в документе — theme и base Tailwind
          // слабее `primeng`, утилиты Tailwind (слой utilities, объявлен позже в src/assets/styles/tailwind.css) сильнее.
          cssLayer: {name: 'primeng', order: 'theme, base, primeng'},
        },
      },
    }),
    DatePipe,
    MessageService,
    DialogService,
    ConfirmationService
  ]
};
